import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo } from 'react';
import { prefixStyle } from '@lada/prefix';
import { systemFontsDefaultLetterSpacing } from '@bubble-ui/particle-system-fonts-default-letter-spacing';
export var Link = _ref => {
  var {
    'aria-label': ariaLabel,
    children,
    designContext,
    disabled,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ellipsizeMode,
    href,
    id,
    numberOfLines,
    onFocus,
    onBlur,
    onMouseDown,
    onMouseOut,
    onMouseOver,
    onMouseUp,
    onPress,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onPressIn,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onPressOut,
    onTouchEnd,
    onTouchStart,
    preventLineBreak,
    rel,
    role,
    style,
    tabIndex,
    target,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    testID,
    turnOffTouchability,
    UNSAFE_props
  } = _ref;
  var handleKeyDown = useCallback(event => {
    if (event.key === 'Enter' && !href) {
      event.preventDefault()
      // Cast `onPress` to `TKeyPressHandler<HTMLAnchorElement>` for type safety, ensuring it handles keyboard events on web appropriately.
      // This is necessary because `onPress` can potentially be a handler for various event types and platforms (web and native).
      // This avoids defining a separate keyboard handler in the API, maintaining `onPress` as the unified action handler for both gesture, mouse and keyboard events.
      ;
      onPress === null || onPress === void 0 ? void 0 : onPress(event);
    }
  }, [onPress, href]);
  var mergedStyles = useMemo(() => {
    var restOfStyles = style || {};
    var letterSpacing = restOfStyles.letterSpacing ? restOfStyles.letterSpacing : systemFontsDefaultLetterSpacing(restOfStyles.fontSize);
    return prefixStyle(_objectSpread(_objectSpread(_objectSpread({}, restOfStyles), restOfStyles.lineHeight && {
      lineHeight: "".concat(restOfStyles.lineHeight, "px")
    }), {}, {
      letterSpacing: "".concat(letterSpacing, "px"),
      fontSmoothing: 'antialiased',
      textRendering: 'geometricPrecision',
      textSizeAdjust: 'none',
      whiteSpace: preventLineBreak && !numberOfLines ? 'nowrap' : undefined,
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString()
    }));
  }, [designContext, numberOfLines, preventLineBreak, style]);
  return turnOffTouchability ? /*#__PURE__*/React.createElement("span", _extends({
    id: id
  }, UNSAFE_props, {
    style: mergedStyles
  }), children) : disabled ? /*#__PURE__*/React.createElement("span", _extends({
    id: id
  }, UNSAFE_props, {
    "aria-disabled": true,
    "aria-label": ariaLabel,
    role: role,
    style: mergedStyles
  }), children) : /*#__PURE__*/React.createElement("a", _extends({
    id: id
  }, UNSAFE_props, {
    "aria-label": ariaLabel,
    href: href,
    onBlur: onBlur,
    onClick: onPress,
    onFocus: onFocus,
    onKeyDown: handleKeyDown,
    onMouseDown: onMouseDown,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchStart: onTouchStart,
    rel: rel,
    role: role,
    style: mergedStyles,
    tabIndex: tabIndex || 0,
    target: target
  }), children);
};
//# sourceMappingURL=Link.js.map